import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

const I18nExample: LitheFC = (): LitheElement<'section'> => {
  return ['section', ['h2', 'I18n Example']];
};

export default I18nExample;
